export default (data) => {
  if (!data) return {};
  const mappedData = { ...data };

  return {
    firstName: mappedData?.customerName,
    lastName: mappedData?.customerSurname,
    fiscalCode: mappedData?.fiscalCode,
    gender: mappedData?.gender,
    occupation: mappedData?.occupation,
    employeer: mappedData?.company,
    zipCode: mappedData?.zipCode,
    city: mappedData?.city,
    state: mappedData?.province,
  };
};
